<div class="lum-c-sales-order-tag-cell-renderer">
  <div
    *ngFor="let tag of tags; trackBy: trackById"
    class="lum-c-sales-order-tag-cell-renderer__tag badge badge-light"
    [ngClass]="{ 'is-collapsed': prefersTagsCollapsed }"
    [ngStyle]="{ '--tag-color': tag.color }"
    [matTooltip]="prefersTagsCollapsed ? tag.name : ''"
    matTooltipPosition="above"
  >
    <span [ngClass]="{ 'sr-only': prefersTagsCollapsed }">{{ tag.name }}</span>
  </div>
</div>
